<template>
  <div class="mfi-info">
    <vbCallout class="margin-bottom-0" :coloring="coloring">
      <div class="grid-x grid-padding-x">
        <div class="cell hide-for-small-only medium-shrink">
          <FontAwesomeIcon icon="info-circle" size="2x" />
        </div>
        <div class="cell small-12 medium-auto flex-container align-middle">
          <p class="margin-bottom-0">{{ mfiInfoMessage.message }}</p>
        </div>
      </div>
    </vbCallout>
  </div>
</template>

<script>
  import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

  export default {
    name: 'MfiInfoMessage',
    props: {
      mfiInfoMessage: {
        default: null,
        type: Object,
      },
      coloring: {
        default: null,
        type: String,
      },
    },
    created () {
      this.$fa.add(faInfoCircle)
    },
  }
</script>

<style lang="scss" scoped>
  @import "~assets/scss/frontend/_colours.scss";
  @import "~assets/scss/frontend/foundation/_settings";
  @import "~foundation-sites/scss/global";

  .mfi-info {
    margin-top: 2rem;
    svg {
      color: $colour-green;
    }

    @include breakpoint (medium) {
      margin-top: 0
    }
  }
</style>
